import { useCallback } from 'react'
import { useAxiosInstances } from '../axios-instance'
import { IPlano, IPlanoCompletoMultiRange, IInserirPlanoRequest, IAtualizarPlanoRequest, IPlanoMultiRangeRequest } from '../../application/models'

export const usePlanosVelesApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const obterPlanoPorClienteApi = useCallback(async (data: {
    IdCliente: number
  }): Promise<IPlanoCompletoMultiRange> => {
    try {
      const result = await axiosAuthInstance.get(`/planos-veles/${data.IdCliente}`)
      const planoData = result.data?.plano?.[0]

      return {
        data: result.data,
        ...planoData       
      } as IPlanoCompletoMultiRange
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const inserirPlanoApi = useCallback(async (data: IInserirPlanoRequest): Promise<IPlano> => {
    try {
      const result = await axiosAuthInstance.post('/planos-veles', data)
      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const atualizarPlanoApi = useCallback(async (data: IAtualizarPlanoRequest): Promise<IPlano> => {
    try {
      const result = await axiosAuthInstance.put('/planos-veles', data)
      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  // FUNÇÕES MULTI-RANGE EXISTENTES (restauradas)
  const inserirPlanoMultiRangeApi = useCallback(async (data: IPlanoMultiRangeRequest): Promise<IPlano> => {
    try {
      const result = await axiosAuthInstance.post('/planos-veles/multi-range', data)
      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const atualizarPlanoMultiRangeApi = useCallback(async (data: IPlanoMultiRangeRequest): Promise<IPlano> => {
    try {
      const result = await axiosAuthInstance.put('/planos-veles/multi-range', data)
      return result.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  // NOVAS FUNÇÕES SIMPLIFICADAS
  const getPlanosVeles = useCallback(async (): Promise<any[]> => {
    try {
      const response = await axiosAuthInstance.get('/planos-veles')
      return response.data || []
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const getPlanoPorCliente = useCallback(async (idCliente: number): Promise<any> => {
    try {
      const response = await axiosAuthInstance.get(`/planos-veles/cliente/${idCliente}`)
      return response.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  // NOVAS FUNÇÕES PARA INTEGRAÇÃO COM CLIENTES
  const salvarPlanoVeles = useCallback(async (data: {
    IdCliente: number,
    [key: string]: any
  }): Promise<any> => {
    try {
      const response = await axiosAuthInstance.post('/planos-veles', data)
      return response.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const atualizarPlanoVeles = useCallback(async (data: {
    IdCliente: number,
    [key: string]: any
  }): Promise<any> => {
    try {
      const response = await axiosAuthInstance.put(`/planos-veles/cliente/${data.IdCliente}`, data)
      return response.data
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const obterHistoricoPlanosApi = useCallback(async (data: {
    IdCliente: number
  }): Promise<any[]> => {
    try {
      // Mocking/Preparando para quando o backend for atualizado
      const result = await axiosAuthInstance.get(`/planos-veles/${data.IdCliente}/historico`)
      return result.data || []
    } catch (error) {
      // Ignora erro por enquanto até criar a rota
      return []
    }
  }, [axiosAuthInstance])

  return {
    obterPlanoPorClienteApi,
    inserirPlanoApi,
    atualizarPlanoApi,
    inserirPlanoMultiRangeApi,
    atualizarPlanoMultiRangeApi,

    // NOVAS FUNÇÕES SIMPLIFICADAS
    getPlanosVeles,
    getPlanoPorCliente,

    // NOVAS FUNÇÕES PARA INTEGRAÇÃO COM CLIENTES
    salvarPlanoVeles,
    atualizarPlanoVeles,
    obterHistoricoPlanosApi
  }
}